'use client';

import Script from 'next/script';

import React, { ReactNode } from 'react';

import Device from '@shared/common/components/Device';
import { getProcessEnvGlobalConfig } from '@shared/config/global';

import Footer from './Footer';
import Header from './Header';

const MainLayout = ({ children }: { children: ReactNode }) => {
  const isDev = getProcessEnvGlobalConfig('isDev');

  return (
    <>
      <Header />
      <div className="pt-header-sm md:pt-header flex-grow">{children}</div>
      <Footer />

      <Script src="https://accounts.google.com/gsi/client" async defer strategy="lazyOnload" />

      <Device>
        {({ isMobile }) =>
          isMobile &&
          isDev && (
            <Script
              src="https://cdn.jsdelivr.net/npm/eruda"
              onLoad={() => {
                // Initialize Eruda
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                eruda.init();
              }}
            />
          )
        }
      </Device>
    </>
  );
};

export default MainLayout;
